// import React, { useRef } from "react";
// import { QRCodeCanvas } from "qrcode.react";

// export default function MerchantQRScreen() {

//   const qrRef = useRef();

//   const marchentdata = JSON.parse(
//     localStorage.getItem("marchentdata") || "{}"
//   );

//   const merchantId =
//     marchentdata?.user_id || "CMV9A117EAC";

//   const businessName =
//     marchentdata?.business_name || "My Restaurant";

//   const qrURL =
//     `https://countmyvisit.com/Apis/customer-checkin?merchant_id=${merchantId}`;

//   const downloadQR = () => {

//     const canvas =
//       qrRef.current.querySelector("canvas");

//     const image =
//       canvas.toDataURL("image/png");

//     const link =
//       document.createElement("a");

//     link.href = image;

//     link.download =
//       `${businessName}_QR.png`;

//     link.click();
//   };

//   return (
//     <div style={styles.container}>

//       <div
//         ref={qrRef}
//         style={styles.card}
//       >

//         <div style={styles.header}>
//           <h1 style={styles.logo}>
//             Count My Visit
//           </h1>

//           <p style={styles.subtitle}>
//             Customer Loyalty Program
//           </p>
//         </div>

//         <div style={styles.businessBox}>
//           <h2>{businessName}</h2>

//           <p>
//             Scan QR To Check-In
//           </p>
//         </div>

//         <div style={styles.qrBox}>
//           <QRCodeCanvas
//             value={qrURL}
//             size={250}
//             level="H"
//           />
//         </div>

//         <div style={styles.footer}>
//           <p>
//             Earn Rewards On Every Visit
//           </p>

//           <small>
//             Powered By CountMyVisit
//           </small>
//         </div>

//       </div>

//       <button
//         style={styles.button}
//         onClick={downloadQR}
//       >
//         Download QR
//       </button>

//       <div style={styles.urlBox}>
//         <strong>QR URL:</strong>

//         <p>{qrURL}</p>
//       </div>

//     </div>
//   );
// }

// const styles = {
//   container: {
//     minHeight: "100vh",
//     background: "#f5f6fa",
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     padding: 20
//   },

//   card: {
//     width: 380,
//     background: "#fff",
//     borderRadius: 20,
//     padding: 20,
//     textAlign: "center",
//     boxShadow:
//       "0 10px 30px rgba(0,0,0,0.15)"
//   },

//   header: {
//     marginBottom: 20
//   },

//   logo: {
//     margin: 0,
//     color: "#0f172a"
//   },

//   subtitle: {
//     color: "#64748b"
//   },

//   businessBox: {
//     marginBottom: 20
//   },

//   qrBox: {
//     display: "flex",
//     justifyContent: "center",
//     marginBottom: 20
//   },

//   footer: {
//     marginTop: 10
//   },

//   button: {
//     marginTop: 20,
//     padding: "12px 25px",
//     background: "#2563eb",
//     color: "#fff",
//     border: "none",
//     borderRadius: 10,
//     cursor: "pointer",
//     fontSize: 16
//   },

//   urlBox: {
//     marginTop: 20,
//     width: 380,
//     background: "#fff",
//     padding: 15,
//     borderRadius: 10,
//     wordBreak: "break-all"
//   }
// };

// import React, { useRef, useEffect, useState } from "react";
// import { QRCodeCanvas } from "qrcode.react";
// import { useNavigate } from "react-router-dom";

// export default function MerchantQRScreen() {
//   const navigate = useNavigate();
//   const qrRef = useRef();
  
//   // Initialized with empty strings to prevent static trace leakage
//   const [merchantId, setMerchantId] = useState("");
//   const [businessName, setBusinessName] = useState("");

//   useEffect(() => {
//     try {
//       // Accessing the local storage layer using 'marchentdata' exactly like last time
//       const savedDataString = localStorage.getItem("marchentdata");
//       if (savedDataString) {
//         const parsedData = JSON.parse(savedDataString);
        
//         // Directly maps fields from the flat object structure
//         if (parsedData) {
//           setMerchantId(parsedData.user_id || "CMVC497B3A688");
//           setBusinessName(parsedData.business_name || "My Restaurant");
//         }
//       } else {
//         // Fallbacks if entry does not exist yet
//         setMerchantId("CMV9A117EAC");
//         setBusinessName("My Restaurant");
//       }
//     } catch (error) {
//       console.error("Error reading data layer payload inside QR Engine:", error);
//       setMerchantId("CMV9A117EAC");
//       setBusinessName("My Restaurant");
//     }
//   }, []);

//   const qrURL = `https://countmyvisit.com/Apis/customer-checkin?merchant_id=${merchantId}`;

//   const downloadQR = () => {
//     const canvas = qrRef.current.querySelector("canvas");
//     if (!canvas) return;
    
//     const image = canvas.toDataURL("image/png");
//     const link = document.createElement("a");
//     link.href = image;
//     link.download = `${businessName.replace(/\s+/g, "_")}_Official_QR.png`;
//     link.click();
//   };

//   return (
//     <div style={styles.container}>
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;600;700;800&display=swap');
//         * { font-family: 'Plus Jakarta Sans', sans-serif; box-sizing: border-box; }
//       `}</style>

//       {/* TOP NAVIGATION HEADER */}
//       <div style={styles.navBar}>
//         <div style={styles.navBrand}>⚡ Count My Visit QR Panel</div>
//         <button style={styles.backBtn} onClick={() => navigate(-1)}>
//           ⬅️ Back to Loyalty Dashboard
//         </button>
//       </div>

//       {/* STANDEE CARD CONTAINER FOR CUSTOMERS */}
//       <div ref={qrRef} style={styles.card}>
//         <div style={styles.cardAccent} />
        
//         <div style={styles.header}>
//           <h1 style={styles.logo}>Count My Visit</h1>
//           <p style={styles.subtitle}>Premium Loyalty Network</p>
//         </div>

//         <div style={styles.businessBox}>
//           <div style={styles.badge}>OFFICIAL PARTNER</div>
//           <h2 style={styles.businessNameText}>{businessName}</h2>
//           <p style={styles.scanInstruction}>Scan QR Code via Camera to Check-In</p>
//         </div>

//         <div style={styles.qrOuterWrapper}>
//           <div style={styles.qrBox}>
//             {/* Conditional rendering occurs only when state mapping finishes to keep data true */}
//             {merchantId && (
//               <QRCodeCanvas
//                 value={qrURL}
//                 size={240}
//                 level="H"
//                 includeMargin={true}
//                 fgColor="#0f172a"
//               />
//             )}
//           </div>
//         </div>

//         <div style={styles.footer}>
//           <p style={styles.footerHighlight}>🎁 Scan • Earn Points • Claim Rewards</p>
//           <small style={styles.poweredBy}>Powered By countmyvisit.com</small>
//         </div>
//       </div>

//       {/* CALL TO ACTIONS */}
//       <div style={styles.controlPanel}>
//         <button style={styles.button} onClick={downloadQR}>
//           📥 Download High-Res PNG
//         </button>
        
//         <div style={styles.urlBox}>
//           <span style={styles.urlLabel}>LIVE REDIRECTION ROUTE:</span>
//           <p style={styles.urlText}>{qrURL}</p>
//         </div>
//       </div>
//     </div>
//   );
// }

// const styles = {
//   container: {
//     minHeight: "100vh",
//     background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     padding: "24px",
//   },
//   navBar: {
//     width: "100%",
//     maxWidth: "430px",
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     background: "#ffffff",
//     padding: "14px 20px",
//     borderRadius: "16px",
//     boxShadow: "0 4px 15px rgba(15, 23, 42, 0.04)",
//     marginBottom: "24px",
//     border: "1px solid #e2e8f0",
//   },
//   navBrand: {
//     fontSize: "14px",
//     fontWeight: "700",
//     color: "#0f172a",
//   },
//   backBtn: {
//     background: "#f1f5f9",
//     border: "none",
//     padding: "8px 14px",
//     borderRadius: "10px",
//     fontSize: "12px",
//     fontWeight: "700",
//     color: "#475569",
//     cursor: "pointer",
//     transition: "0.2s",
//   },
//   card: {
//     width: "100%",
//     maxWidth: "430px",
//     background: "#ffffff",
//     borderRadius: "32px",
//     padding: "40px 32px",
//     textAlign: "center",
//     boxShadow: "0 25px 50px -12px rgba(15, 23, 42, 0.12)",
//     position: "relative",
//     overflow: "hidden",
//     border: "1px solid #f1f5f9",
//   },
//   cardAccent: {
//     position: "absolute",
//     top: 0,
//     left: 0,
//     right: 0,
//     height: "8px",
//     background: "linear-gradient(90deg, #ff8c42, #ff5e62)",
//   },
//   header: {
//     marginBottom: "28px",
//   },
//   logo: {
//     margin: 0,
//     fontSize: "26px",
//     fontWeight: "800",
//     letterSpacing: "-0.5px",
//     background: "linear-gradient(135deg, #ff8c42, #ff5e62)",
//     WebkitBackgroundClip: "text",
//     WebkitTextFillColor: "transparent",
//   },
//   subtitle: {
//     margin: "4px 0 0 0",
//     color: "#64748b",
//     fontSize: "13px",
//     fontWeight: "600",
//     textTransform: "uppercase",
//     letterSpacing: "0.75px",
//   },
//   businessBox: {
//     marginBottom: "24px",
//   },
//   badge: {
//     display: "inline-block",
//     background: "#fff7ed",
//     color: "#ea580c",
//     fontSize: "10px",
//     fontWeight: "800",
//     padding: "4px 10px",
//     borderRadius: "20px",
//     letterSpacing: "0.5px",
//     marginBottom: "10px",
//   },
//   businessNameText: {
//     margin: 0,
//     fontSize: "28px",
//     fontWeight: "800",
//     color: "#0f172a",
//     textTransform: "capitalize",
//     lineHeight: "1.2",
//   },
//   scanInstruction: {
//     margin: "8px 0 0 0",
//     color: "#64748b",
//     fontSize: "14px",
//     fontWeight: "500",
//   },
//   qrOuterWrapper: {
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     background: "#f8fafc",
//     padding: "24px",
//     borderRadius: "24px",
//     border: "2px dashed #cbd5e1",
//     marginBottom: "28px",
//   },
//   qrBox: {
//     background: "#ffffff",
//     padding: "12px",
//     borderRadius: "16px",
//     boxShadow: "0 10px 25px rgba(0, 0, 0, 0.04)",
//   },
//   footer: {
//     marginTop: "12px",
//   },
//   footerHighlight: {
//     margin: 0,
//     fontSize: "15px",
//     fontWeight: "700",
//     color: "#0f172a",
//   },
//   poweredBy: {
//     display: "block",
//     marginTop: "8px",
//     color: "#94a3b8",
//     fontSize: "11px",
//     fontWeight: "600",
//     textTransform: "uppercase",
//     letterSpacing: "0.5px",
//   },
//   controlPanel: {
//     width: "100%",
//     maxWidth: "430px",
//     textAlign: "center",
//   },
//   button: {
//     marginTop: "24px",
//     width: "100%",
//     height: "54px",
//     background: "linear-gradient(135deg, #ff8c42, #ff5e62)",
//     color: "#ffffff",
//     border: "none",
//     borderRadius: "14px",
//     cursor: "pointer",
//     fontSize: "16px",
//     fontWeight: "600",
//     transition: "all 0.2s ease",
//     boxShadow: "0 10px 20px -5px rgba(255, 94, 98, 0.3)",
//   },
//   urlBox: {
//     marginTop: "20px",
//     background: "rgba(255, 255, 255, 0.6)",
//     padding: "14px",
//     borderRadius: "14px",
//     border: "1px dashed #cbd5e1",
//     textAlign: "left",
//   },
//   urlLabel: {
//     display: "block",
//     fontSize: "10px",
//     fontWeight: "800",
//     color: "#64748b",
//     letterSpacing: "0.5px",
//     marginBottom: "4px",
//   },
//   urlText: {
//     margin: 0,
//     fontSize: "12px",
//     color: "#334155",
//     wordBreak: "break-all",
//     fontWeight: "500",
//   },
// };

import React, { useRef, useEffect, useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { useNavigate } from "react-router-dom";

export default function MerchantQRScreen() {
  const navigate = useNavigate();
  const qrRef = useRef();
  
  const [merchantId, setMerchantId] = useState("");
  const [businessName, setBusinessName] = useState("");


  useEffect(() => {
  try {
    const savedDataString = localStorage.getItem("marchentdata");

    if (!savedDataString) {
      navigate("/merchantlogin"); // ya jo login route hai
      return;
    }

    const parsedData = JSON.parse(savedDataString);

    console.log("Merchant Data:", parsedData);

    setMerchantId(parsedData?.merchant?.user_id || "");
    setBusinessName(parsedData?.merchant?.business_name || "");

  } catch (error) {
    console.error("Error reading merchant data:", error);
    navigate("/merchantlogin");
  }
}, []);
  // useEffect(() => {
  //   try {
  //     const savedDataString = localStorage.getItem("marchentdata");
  //     console.log('i am data marchent',savedDataString)
  //     if (savedDataString) {
  //       const parsedData = JSON.parse(savedDataString);
  //       if (parsedData) {
  //         setMerchantId(parsedData.user_id || "CMVC497B3A688");
  //         setBusinessName(parsedData.business_name || "My Restaurant");
  //       }
  //     } else {
  //       setMerchantId("CMV9A117EAC");
  //       setBusinessName("My Restaurant");
  //     }
  //   } catch (error) {
  //     console.error("Error reading data layer payload inside QR Engine:", error);
  //     setMerchantId("CMV9A117EAC");
  //     setBusinessName("My Restaurant");
  //   }
  // }, []);

  const qrURL = `https://countmyvisit.com/Apis/customer-checkin?merchant_id=${merchantId}`;

  const downloadQR = () => {
    const canvas = qrRef.current.querySelector("canvas");
    if (!canvas) return;
    
    const image = canvas.toDataURL("image/png");
    const link = document.createElement("a");
    link.href = image;
    link.download = `${businessName.replace(/\s+/g, "_")}_Official_QR.png`;
    link.click();
  };

  return (
    <div className="screen-wrapper">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&display=swap');
        
        * { 
          font-family: 'Plus Jakarta Sans', sans-serif; 
          box-sizing: border-box; 
          margin: 0; 
          padding: 0; 
        }

        .screen-wrapper {
          min-height: 100vh;
          background: #f8fafc;
          color: #0f172a;
          display: flex;
          flex-direction: column;
        }

        /* Responsive Layout Engine */
        .workspace-layout {
          display: grid;
          grid-template-columns: 1.2fr 1fr; /* Laptop Structure */
          gap: 40px;
          max-width: 1200px;
          width: 100%;
          margin: 0 auto;
          padding: 0 24px 40px 24px;
          align-items: start;
        }

        .nav-container {
          width: 100%;
          max-width: 1200px;
          margin: 0 auto;
          padding: 24px;
          display: flex;
          justify-content: space-between;
          align-items: center;
        }

        .nav-brand {
          font-size: 16px;
          font-weight: 800;
          color: #0f172a;
          display: flex;
          align-items: center;
          gap: 8px;
        }

        .pulse-indicator {
          width: 8px;
          height: 8px;
          background: #10b981;
          border-radius: 50%;
          box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.4);
          animation: pulse-ring 1.5s infinite;
        }

        @keyframes pulse-ring {
          0% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(16, 185, 129, 0.5); }
          70% { transform: scale(1); box-shadow: 0 0 0 8px rgba(16, 185, 129, 0); }
          100% { transform: scale(0.95); box-shadow: 0 0 0 0 rgba(16, 185, 129, 0); }
        }

        .back-btn {
          background: #ffffff;
          border: 1px solid #e2e8f0;
          padding: 10px 18px;
          borderRadius: 12px;
          font-size: 13px;
          font-weight: 700;
          color: #475569;
          cursor: pointer;
          display: flex;
          align-items: center;
          gap: 6px;
          transition: all 0.2s ease;
          border-radius: 12px;
        }

        .back-btn:hover {
          background: #f1f5f9;
          color: #0f172a;
        }

        /* Info & Config Panel Left Side */
        .config-panel {
          background: #ffffff;
          border: 1px solid #e2e8f0;
          border-radius: 24px;
          padding: 32px;
          box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.02);
        }

        .panel-tag {
          display: inline-block;
          background: #eeebff;
          color:   linear-gradient(135deg, #ff8c42, #ff5e62);
          font-size: 11px;
          fontWeight: 700;
          padding: 6px 12px;
          border-radius: 8px;
          margin-bottom: 16px;
          font-weight: 700;
        }

        .panel-title {
          font-size: 28px;
          font-weight: 800;
          color: #0f172a;
          letter-spacing: -0.5px;
          line-height: 1.2;
        }

        .panel-desc {
          font-size: 15px;
          color: #64748b;
          margin-top: 8px;
          line-height: 1.5;
        }

        .action-button {
          width: 100%;
          height: 56px;
           background: linear-gradient(135deg, #ff8c42, #ff5e62);
          color: #ffffff;
          border: none;
          border-radius: 14px;
          font-size: 15px;
          font-weight: 700;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 10px;
          margin-top: 28px;
          transition: all 0.2s ease;
        }

        .action-button:hover {
           background: linear-gradient(135deg, #ff8c42, #ff5e62);
          transform: translateY(-1px);
        }

        .url-card {
          background: #f8fafc;
          border: 1px dashed #cbd5e1;
          border-radius: 14px;
          padding: 16px;
          margin-top: 24px;
        }

        .url-label {
          font-size: 11px;
          font-weight: 700;
          color: #64748b;
          letter-spacing: 0.5px;
        }

        .url-text {
          font-size: 13px;
          color: #334155;
          font-family: monospace;
          word-break: break-all;
          margin-top: 6px;
          font-weight: 500;
        }

        /* Premium Standee Preview Right Side */
        .standee-preview-container {
          display: flex;
          justify-content: center;
          position: sticky;
          top: 40px;
        }

        .standee-card {
          width: 100%;
          max-width: 380px;
          background: #ffffff;
          border-radius: 36px;
          padding: 44px 32px 32px 32px;
          border: 1px solid #e2e8f0;
          box-shadow: 0 25px 50px -12px rgba(15, 23, 42, 0.08);
          position: relative;
          overflow: hidden;
          text-align: center;
        }

        .standee-accent {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 10px;
           background: linear-gradient(135deg, #ff8c42, #ff5e62);
        }

        .standee-logo {
          font-size: 22px;
          font-weight: 800;
          color: #0f172a;
          letter-spacing: -0.5px;
        }

        .partner-badge {
          display: inline-block;
          background: #f1f5f9;
          color: #475569;
          font-size: 9px;
          font-weight: 700;
          padding: 4px 10px;
          border-radius: 100px;
          margin-top: 6px;
          letter-spacing: 0.5px;
        }

        .standee-biz-name {
          font-size: 30px;
          font-weight: 800;
          color: #0f172a;
          margin-top: 24px;
          line-height: 1.2;
          letter-spacing: -0.5px;
        }

        .standee-instruction {
          font-size: 13px;
          color: #64748b;
          margin-top: 6px;
          font-weight: 500;
        }

        .qr-frame-wrapper {
          background: #f8fafc;
          border: 1px solid #e2e8f0;
          border-radius: 24px;
          padding: 24px;
          margin: 28px 0;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .qr-white-box {
          background: #ffffff;
          padding: 12px;
          border-radius: 16px;
          box-shadow: 0 10px 20px -10px rgba(0,0,0,0.06);
          border: 1px solid #f1f5f9;
        }

        .perks-pill-row {
          display: flex;
          justify-content: center;
          gap: 12px;
          font-size: 13px;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 12px;
        }

        .brand-link-footer {
          font-size: 11px;
          color: #94a3b8;
          font-weight: 600;
          letter-spacing: 0.5px;
          text-transform: uppercase;
        }

        /* ================= MEDIA BREAKPOINTS ================= */

        /* टैबलेट व्यू (Tablets: 769px - 1024px) */
        @media (max-width: 1024px) {
          .workspace-layout {
            grid-template-columns: 1fr; /* सिंगल ग्रिड फ्लो */
            gap: 32px;
          }
          .standee-preview-container {
            position: relative;
            top: 0;
          }
          .standee-card {
            max-width: 100%; /* कार्ड को चौड़ा और टैबलेट रेस्पॉन्सिव बनाएं */
          }
        }

        /* मोबाइल व्यू (Smartphones: Up to 768px) */
        @media (max-width: 768px) {
          .nav-container {
            padding: 16px;
          }
          .workspace-layout {
            grid-template-columns: 1fr !important;
            padding: 0 16px 24px 16px;
            gap: 24px;
          }
          .config-panel {
            padding: 20px;
            border-radius: 20px;
          }
          .panel-title {
            font-size: 22px;
          }
          .standee-card {
            border-radius: 28px;
            padding: 32px 20px 24px 20px;
          }
          .standee-biz-name {
            font-size: 24px;
          }
          .action-button {
            height: 50px;
            font-size: 14px;
            margin-top: 20px;
          }
        }
      `}</style>

      {/* TOP COMPACT NAV BAR */}
      <div className="nav-container">
        <div className="nav-brand">
          <div className="pulse-indicator" />
          <span>Count My Visit Engine</span>
        </div>
        {/* <button className="back-btn" onClick={() => navigate(-1)}>
          ← Dashboard
        </button> */}
      </div>

      {/* DYNAMIC WORKSPACE GRID */}
      <div className="workspace-layout">
        
        {/* LEFT COMPONENT: CONTROL AND DETAILS PANEL */}
        <div className="config-panel">
          <span className="panel-tag">MARKTING STAND UTILITY</span>
          <h1 className="panel-title">Your Live Storefront QR Identity</h1>
          <p className="panel-desc">
            This QR code acts as your physical location check-in point. Customers scan this via mobile camera to seamlessly join your loyalty loop, register visits, and claim rewards.
          </p>

          <button className="action-button" onClick={downloadQR}>
            📥 Download High-Res Standee Graphic (PNG)
          </button>

          <div className="url-card">
            <span className="url-label">LIVE TARGET OVERLAY REDIRECTION:</span>
            <p className="url-text">{qrURL}</p>
          </div>
        </div>

        {/* RIGHT COMPONENT: PREMIUM REAL-TIME STANDEE CARD CARD */}
        <div className="standee-preview-container">
          <div ref={qrRef} className="standee-card">
            <div className="standee-accent" />
            
            <div>
              <div className="standee-logo">Count My Visit</div>
              <span className="partner-badge">OFFICIAL NETWORK NODE</span>
            </div>

            <div>
              <h2 className="standee-biz-name">{businessName}</h2>
              <p className="standee-instruction">Scan QR with your camera to check-in</p>
            </div>

            <div className="qr-frame-wrapper">
              <div className="qr-white-box">
                {merchantId && (
                  <QRCodeCanvas
                    value={qrURL}
                    size={200}
                    level="H"
                    includeMargin={false}
                    fgColor="#0f172a"
                  />
                )}
              </div>
            </div>

            <div>
              <div className="perks-pill-row">
                <span>✨ Scan</span>
                <span style={{ color: "#cbd5e1" }}>•</span>
                <span>🎁 Earn</span>
                <span style={{ color: "#cbd5e1" }}>•</span>
                <span>🔥 Redeem</span>
              </div>
              <span className="brand-link-footer">countmyvisit.com</span>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}

// import React, { useRef, useEffect, useState } from "react";
// import { QRCodeCanvas } from "qrcode.react";
// import { useNavigate } from "react-router-dom";

// export default function MerchantQRScreen() {
//   const navigate = useNavigate();
//   const qrRef = useRef();
  
//   const [merchantId, setMerchantId] = useState("");
//   const [businessName, setBusinessName] = useState("");
//   const [copied, setCopied] = useState(false);

//   useEffect(() => {
//     try {
//       const savedDataString = localStorage.getItem("marchentdata");
//       if (savedDataString) {
//         const parsedData = JSON.parse(savedDataString);
//         if (parsedData) {
//           setMerchantId(parsedData.user_id || "CMV9A117EAC");
//           setBusinessName(parsedData.business_name || "My Restaurant");
//         }
//       } else {
//         setMerchantId("CMV9A117EAC");
//         setBusinessName("My Restaurant");
//       }
//     } catch (error) {
//       console.error("Data sync failure:", error);
//       setMerchantId("CMV9A117EAC");
//       setBusinessName("My Restaurant");
//     }
//   }, []);

//   const qrURL = `https://countmyvisit.com/Apis/customer-checkin?merchant_id=${merchantId}`;

//   const downloadQR = () => {
//     const canvas = qrRef.current.querySelector("canvas");
//     if (!canvas) return;
    
//     const image = canvas.toDataURL("image/png");
//     const link = document.createElement("a");
//     link.href = image;
//     link.download = `${businessName.replace(/\s+/g, "_")}_HQ_Pass.png`;
//     link.click();
//   };

//   const copyToClipboard = () => {
//     navigator.clipboard.writeText(qrURL);
//     setCopied(true);
//     setTimeout(() => setCopied(false), 2000);
//   };

//   return (
//     <div style={styles.container}>
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');
//         * { font-family: 'Inter', sans-serif; box-sizing: border-box; transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1); }
//         button:hover { transform: translateY(-2px); opacity: 0.95; }
//         button:active { transform: translateY(0); }
//       `}</style>

//       {/* PREMIUM HEADER CONTROLS */}
//       <div style={styles.topControlLayer}>
//         <button style={styles.minimalBackBtn} onClick={() => navigate(-1)}>
//           <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>
//           Back to Terminal
//         </button>
//         <span style={styles.statusPill}>● Live System Sync</span>
//       </div>

//       <div style={styles.workspace}>
//         {/* CARD PRESENTATION MECHANISM */}
//         <div ref={qrRef} style={styles.premiumCard}>
//           <div style={styles.topAccentGlow} />
          
//           <div style={styles.brandMeta}>
//             <div style={styles.brandIcon}>⚜️</div>
//             <div>
//               <h1 style={styles.mainTitle}>COUNT MY VISIT</h1>
//               <p style={styles.tagline}>Verified Merchant Network</p>
//             </div>
//           </div>

//           <div style={styles.divider} />

//           <div style={styles.merchantIdentityArea}>
//             <span style={styles.identityLabel}>EXCLUSIVE VENUE</span>
//             <h2 style={styles.merchantName}>{businessName}</h2>
//           </div>

//           <div style={styles.qrDisplayMatrix}>
//             <div style={styles.innerQrFrame}>
//               {merchantId && (
//                 <QRCodeCanvas
//                   value={qrURL}
//                   size={220}
//                   level="Q"
//                   includeMargin={false}
//                   fgColor="#030712"
//                   bgColor="#ffffff"
//                 />
//               )}
//             </div>
//             <div style={styles.scannerCornerTL} />
//             <div style={styles.scannerCornerTR} />
//             <div style={styles.scannerCornerBL} />
//             <div style={styles.scannerCornerBR} />
//           </div>

//           <p style={styles.actionPrompt}>Scan to unlock reward tiers</p>

//           <div style={styles.cardFooterInfo}>
//             <div style={styles.secureBadge}>
//               <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path></svg>
//               Encrypted Pass Vector
//             </div>
//             <span style={styles.serialNumber}>ID: {merchantId}</span>
//           </div>
//         </div>

//         {/* SIDE BAR UTILITIES CONTROLS */}
//         <div style={styles.utilitySidebar}>
//           <div style={styles.utilityHeader}>
//             <h3 style={styles.utilityTitle}>Asset Management</h3>
//             <p style={styles.utilityDesc}>Deploy your physical customer check-in hub point.</p>
//           </div>

//           <button style={styles.primaryActionBtn} onClick={downloadQR}>
//             <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" style={{marginRight: 8}}><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" y1="15" x2="12" y2="3"></line></svg>
//             Download Print-Ready HQ Asset
//           </button>

//           <div style={styles.interactiveUrlPanel}>
//             <div style={styles.urlHeaderContainer}>
//               <span style={styles.urlPanelLabel}>PASS REDIRECTION INDEX</span>
//               <button style={styles.copyTextLink} onClick={copyToClipboard}>
//                 {copied ? "✓ Copied" : "Copy Link"}
//               </button>
//             </div>
//             <div style={styles.urlStringContainer}>
//               <span style={styles.urlEndpointPrefix}>GET</span>
//               <p style={styles.urlValueText}>{qrURL}</p>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// const styles = {
//   container: {
//     minHeight: "100vh",
//     backgroundColor: "#030712",
//     backgroundImage: "radial-gradient(circle at 50% 0%, #1e1b4b 0%, #030712 70%)",
//     display: "flex",
//     flexDirection: "column",
//     alignItems: "center",
//     padding: "40px 24px",
//     color: "#f3f4f6",
//   },
//   topControlLayer: {
//     width: "100%",
//     maxWidth: "860px",
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     marginBottom: "32px",
//   },
//   minimalBackBtn: {
//     background: "rgba(255, 255, 255, 0.03)",
//     border: "1px solid rgba(255, 255, 255, 0.08)",
//     padding: "10px 18px",
//     borderRadius: "12px",
//     fontSize: "13px",
//     fontWeight: "600",
//     color: "#9ca3af",
//     cursor: "pointer",
//     display: "flex",
//     alignItems: "center",
//     gap: "8px",
//   },
//   statusPill: {
//     fontSize: "12px",
//     fontWeight: "600",
//     color: "#10b981",
//     background: "rgba(16, 185, 129, 0.06)",
//     padding: "6px 14px",
//     borderRadius: "20px",
//     border: "1px solid rgba(16, 185, 129, 0.15)",
//   },
//   workspace: {
//     width: "100%",
//     maxWidth: "860px",
//     display: "flex",
//     flexDirection: "row",
//     gap: "40px",
//     alignItems: "center",
//     justifyContent: "center",
//     flexWrap: "wrap",
//   },
//   premiumCard: {
//     width: "380px",
//     background: "rgba(10, 11, 18, 0.7)",
//     backdropFilter: "blur(20px)",
//     borderRadius: "28px",
//     padding: "36px",
//     border: "1px solid rgba(255, 255, 255, 0.08)",
//     boxShadow: "0 30px 60px -15px rgba(0,0,0,0.8), inset 0 1px 0 rgba(255,255,255,0.1)",
//     position: "relative",
//     overflow: "hidden",
//   },
//   topAccentGlow: {
//     position: "absolute",
//     top: 0,
//     left: "10%",
//     right: "10%",
//     height: "2px",
//     background: "linear-gradient(90deg, transparent, #6366f1, #a855f7, transparent)",
//   },
//   brandMeta: {
//     display: "flex",
//     alignItems: "center",
//     gap: "14px",
//     textAlign: "left",
//   },
//   brandIcon: {
//     width: "40px",
//     height: "40px",
//     background: "rgba(255,255,255,0.03)",
//     border: "1px solid rgba(255,255,255,0.08)",
//     borderRadius: "10px",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     fontSize: "18px",
//   },
//   mainTitle: {
//     margin: 0,
//     fontSize: "15px",
//     fontWeight: "800",
//     letterSpacing: "2px",
//     color: "#ffffff",
//   },
//   tagline: {
//     margin: "2px 0 0 0",
//     fontSize: "11px",
//     color: "#6b7280",
//     fontWeight: "500",
//     textTransform: "uppercase",
//     letterSpacing: "0.5px",
//   },
//   divider: {
//     height: "1px",
//     background: "linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0.06) 50%, rgba(255,255,255,0) 100%)",
//     margin: "24px 0",
//   },
//   merchantIdentityArea: {
//     textAlign: "center",
//     marginBottom: "28px",
//   },
//   identityLabel: {
//     fontSize: "10px",
//     fontWeight: "700",
//     color: "#818cf8",
//     letterSpacing: "1.5px",
//   },
//   merchantName: {
//     margin: "6px 0 0 0",
//     fontSize: "26px",
//     fontWeight: "700",
//     color: "#ffffff",
//     letterSpacing: "-0.5px",
//   },
//   qrDisplayMatrix: {
//     position: "relative",
//     padding: "24px",
//     background: "rgba(255,255,255,0.01)",
//     borderRadius: "20px",
//     display: "flex",
//     justifyContent: "center",
//     alignItems: "center",
//     marginBottom: "24px",
//   },
//   innerQrFrame: {
//     background: "#ffffff",
//     padding: "14px",
//     borderRadius: "14px",
//     boxShadow: "0 20px 40px rgba(0,0,0,0.4)",
//   },
//   scannerCornerTL: { position: "absolute", top: 12, left: 12, width: 16, height: 16, borderTop: "2px solid #6366f1", borderLeft: "2px solid #6366f1" },
//   scannerCornerTR: { position: "absolute", top: 12, right: 12, width: 16, height: 16, borderTop: "2px solid #6366f1", borderRight: "2px solid #6366f1" },
//   scannerCornerBL: { position: "absolute", bottom: 12, left: 12, width: 16, height: 16, borderBottom: "2px solid #6366f1", borderLeft: "2px solid #6366f1" },
//   scannerCornerBR: { position: "absolute", bottom: 12, right: 12, width: 16, height: 16, borderBottom: "2px solid #6366f1", borderRight: "2px solid #6366f1" },
//   actionPrompt: {
//     fontSize: "13px",
//     color: "#9ca3af",
//     fontWeight: "500",
//     margin: "0 0 28px 0",
//     textAlign: "center",
//   },
//   cardFooterInfo: {
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     fontSize: "11px",
//     color: "#4b5563",
//     fontWeight: "600",
//   },
//   secureBadge: {
//     display: "flex",
//     alignItems: "center",
//     gap: "5px",
//     color: "#4b5563",
//   },
//   serialNumber: {
//     fontFamily: "monospace",
//   },
//   utilitySidebar: {
//     flex: 1,
//     minWidth: "320px",
//     display: "flex",
//     flexDirection: "column",
//     gap: "20px",
//   },
//   utilityHeader: {
//     textAlign: "left",
//   },
//   utilityTitle: {
//     margin: 0,
//     fontSize: "20px",
//     fontWeight: "700",
//     color: "#ffffff",
//   },
//   utilityDesc: {
//     margin: "4px 0 0 0",
//     fontSize: "14px",
//     color: "#9ca3af",
//     lineHeight: "1.5",
//   },
//   primaryActionBtn: {
//     width: "100%",
//     height: "50px",
//     background: "#ffffff",
//     color: "#030712",
//     border: "none",
//     borderRadius: "14px",
//     fontSize: "14px",
//     fontWeight: "600",
//     cursor: "pointer",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     boxShadow: "0 10px 25px -5px rgba(255,255,255,0.1)",
//   },
//   interactiveUrlPanel: {
//     background: "rgba(255,255,255,0.02)",
//     border: "1px solid rgba(255,255,255,0.05)",
//     borderRadius: "16px",
//     padding: "16px",
//   },
//   urlHeaderContainer: {
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     marginBottom: "10px",
//   },
//   urlPanelLabel: {
//     fontSize: "10px",
//     fontWeight: "700",
//     color: "#6b7280",
//     letterSpacing: "0.5px",
//   },
//   copyTextLink: {
//     background: "none",
//     border: "none",
//     color: "#6366f1",
//     fontSize: "12px",
//     fontWeight: "600",
//     cursor: "pointer",
//     padding: 0,
//   },
//   urlStringContainer: {
//     display: "flex",
//     alignItems: "center",
//     background: "rgba(0,0,0,0.3)",
//     padding: "10px 12px",
//     borderRadius: "10px",
//     gap: "10px",
//     border: "1px solid rgba(255,255,255,0.03)",
//   },
//   urlEndpointPrefix: {
//     fontSize: "10px",
//     fontWeight: "700",
//     color: "#10b981",
//     background: "rgba(16, 185, 129, 0.1)",
//     padding: "2px 6px",
//     borderRadius: "4px",
//   },
//   urlValueText: {
//     margin: 0,
//     fontSize: "12px",
//     color: "#9ca3af",
//     wordBreak: "break-all",
//     textAlign: "left",
//     fontWeight: "500",
//   },
// };